import { deregisterOddsSideEffects, registerOddsSideEffects } from './odds.side-effects'
import {
  deregisterQuaddieTipsSideEffects,
  registerQuaddieTipsSideEffects,
} from './quaddie-tips-side-effects'

export function registerSideEffects() {
  registerOddsSideEffects()
  registerQuaddieTipsSideEffects()
}

export function deregisterSideEffects() {
  deregisterOddsSideEffects()
  deregisterQuaddieTipsSideEffects()
}
